import { render, staticRenderFns } from "./chartBars.vue?vue&type=template&id=c3bc607e&scoped=true&"
import script from "./chartBars.vue?vue&type=script&lang=js&"
export * from "./chartBars.vue?vue&type=script&lang=js&"
import style0 from "./chartBars.vue?vue&type=style&index=0&id=c3bc607e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bc607e",
  null
  
)

export default component.exports